export default "__VITE_ASSET__Dtgcf3Ap__"